import gql from "graphql-tag";

export default gql`
  query($id: String!) {
    artwork(id: $id) {
      id
      title
      categories {
        id
        title
      }
      width
      height
      templates {
        title
        isDefault
        layers
        preview
        thumbnail
      }
      lock
      sharedLayers
      templateDisplayMode
      templateDisplayLabel
    }
  }
`;
